// extracted by mini-css-extract-plugin
export var caret = "BetSelectionAutomation-module--caret--b4e63";
export var clampText = "BetSelectionAutomation-module--clampText--61ecf";
export var clock = "BetSelectionAutomation-module--clock--cf4b4";
export var close = "BetSelectionAutomation-module--close--92749";
export var container = "BetSelectionAutomation-module--container--2e2bd";
export var content = "BetSelectionAutomation-module--content--e444b";
export var dashedLine = "BetSelectionAutomation-module--dashedLine--652cc";
export var description = "BetSelectionAutomation-module--description--5b768";
export var iconWrapper = "BetSelectionAutomation-module--iconWrapper--22a97";
export var inProgress = "BetSelectionAutomation-module--inProgress--62d08";
export var link = "BetSelectionAutomation-module--link--b4fc7";
export var name = "BetSelectionAutomation-module--name--f72f8";
export var notPaid = "BetSelectionAutomation-module--notPaid--afe62";
export var paid = "BetSelectionAutomation-module--paid--dac57";
export var payout = "BetSelectionAutomation-module--payout--f4abf";
export var perkIcon = "BetSelectionAutomation-module--perkIcon--bebaf";
export var promoIcon = "BetSelectionAutomation-module--promoIcon--1019b";
export var promoIcons = "BetSelectionAutomation-module--promoIcons--3efa0";
export var promoIconsContainer = "BetSelectionAutomation-module--promoIconsContainer--5898d";
export var statusClamp = "BetSelectionAutomation-module--statusClamp--6988f";
export var winningsBoost = "BetSelectionAutomation-module--winningsBoost--09a3e";